import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Modal, Breadcrumb, Typography, Spin } from 'antd';
import { backButton, formItemLayout, tailFormItemLayout, unexpectedError } from '../../../common_functions';

const SignaturePlacement = props => {
  const { section, id } = useParams();
  const [signaturePlacement, setSignaturePlacement] = useState({});
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        if (id !== 'new') {
          const { data } = await props.getItem('signature_placement', id);
          setSignaturePlacement(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    let newState = {
      ...signaturePlacement,
      ...values,
    };
    try {
      setLoading(true);
      let { data } = await props.saveItem('signature_placement', newState);
      if (data) {
        notification['success']({
          message: 'Signature Read Placement saved successfully!',
          duration: 2,
        });
        backButton(props, `/settings/signature-placement`);
      }
    } catch (error) {
      setLoading(false);
      Modal.warning({
        title: 'Error',
        content: 'Not Saved!',
      });
    }
    setLoading(false);
  };
  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };

  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/signature-placement" }, { title: "Signature Read Placement", href: "/settings/signature-placement" }, { title: id !== 'new' ? `Edit Signature Read Placement` : 'Add Signature Read Placement' }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id !== 'new' ? `Edit Signature Read Placement: ${id}` : 'Add Signature Read Placement'}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="signature"
                    label="Signature Read Placement"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Signature Read Placement is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Signature Read Placement" />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => backButton(props, '/settings/signature-placement')}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(
                  props.roleType,
                  props.tabs_permissions.settings_signature_placement,
                  !!signaturePlacement ? signaturePlacement.id : ''
                )}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default SignaturePlacement;
